<template lang="pug">
  nav.menubar
    a.menubar-item.menubar-toggle(v-if="backLink" @click="$router.go(-1)")
      b-icon(icon="arrow-left")
    a.menubar-item.menubar-toggle.has-text-grey(v-else @click="clickToggle")
      b-icon(:icon="isExpanded ? 'menu-open' : 'menu'")


    //- Меню администратора
    ui-menu(:menu="menu" v-slot="{route, label, icon, attr}")
      b-tooltip.menubar-item.is-animated(
        :label="label"
        position="is-right"
        :type="attr.class"
        :active="!isExpanded"
      )
        router-link.menubar-link(:to="route" :class="attr.class")
          b-icon(v-if="icon" :icon="icon")
          span.menubar-label {{ label }}
          b-tag.is-danger.is-rounded(v-if="attr.badge") {{ attr.badge }}
</template>

<script>
export default {
  name: 'ui-menubar',

  props: {
    backLink: Boolean,
    menu: Array,
    expanded: Boolean,
  },

  data: () => ({
    isExpanded: false,
  }),

  methods: {
    clickToggle() {
      this.isExpanded = !this.isExpanded;

      document.documentElement.classList.toggle('has-menubar-expanded', this.isExpanded);
    },
  },
};
</script>
